import { CssBaseline } from '@mui/material';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FormatterProvider } from './context/FormatterContext';
import { I18nProvider } from './context/I18nContext';
import { NotificationProvider } from './context/NotificationContext';
import { ThemeProvider } from './context/ThemeContext';
import { RecalculationStatusProvider } from './context/RecalculationStatusContext';
import { IntegrationsStatusProvider } from './context/IntegrationsStatusContext';
import LoadingFallback from './LoadingFallback';
import { CelloProvider } from './context/CelloContext';
import AppContent from './AppContent';
import AdminImpersonationOverlay from './components/admin/AdminImpersonationOverlay';

const App = () => {
    return (
        <Suspense fallback={<LoadingFallback />}>
            <Router>
                <ThemeProvider>
                    <CssBaseline />
                    <AuthProvider>
                        <I18nProvider>
                            <FormatterProvider>
                                <IntegrationsStatusProvider>
                                    <RecalculationStatusProvider>
                                        <NotificationProvider>
                                            <CelloProvider>
                                                <AppContent />
                                                <AdminImpersonationOverlay />
                                            </CelloProvider>
                                        </NotificationProvider>
                                    </RecalculationStatusProvider>
                                </IntegrationsStatusProvider>
                            </FormatterProvider>
                        </I18nProvider>
                    </AuthProvider>
                    {import.meta.env.MODE === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
                </ThemeProvider>
            </Router>
        </Suspense>
    );
};

export default App;
